import { Component } from '@angular/core';

@Component({
  selector: 'app-create-provider',
  template: ``,
  styleUrls: []
})
export class CreateProviderComponent {

}
